module.exports = __webpack_public_path__ + "a99733bd09c20ee4ab5301075f54fd66.ttf";